import React, { useState, useRef } from 'react';

import {
  NavLink,
  useLocation
} from 'react-router-dom';

import DisabledTooltip from './disabled-tooltip';

import './index.scss';

function NavItem(props) {

  const { search } = useLocation();

  const { to, activeClassName, className, title, onClick: originalClickHandler } = props;

  const [tooltipVisible, setTooltipVisible] = useState(false);

  const wrapperRef = useRef(null);

  const navLinkProps = {
    to: to + search,
    className: getAppliedClassNames,
    onMouseEnter() {
      if (props.disabled === true) {
        setTooltipVisible(true);
      }
    },
    onMouseLeave() {
      setTooltipVisible(false);
    },
    onClick(event) {

      if (props.disabled === true) {
        event.preventDefault();
        return;
      }

      originalClickHandler(event);

    }
  };

  function getAppliedClassNames({ isActive }) {

    if (isActive === true) {
      return [className, activeClassName, 'venturz-nav-item'].join(' ');
    }

    return [className, 'venturz-nav-item'].join(' ');

  }

  return <div className="nav-item-wrapper" ref={wrapperRef}>
    <NavLink {...navLinkProps}>
      {props.children}
    </NavLink>
    <DisabledTooltip visible={tooltipVisible} text={props.disabledReason} anchorElement={wrapperRef.current} />
  </div>;

}

export default NavItem;